import { getCloudinaryThemeFileUrl } from '@/integrations/cloudinary/helpers'

interface Props {
  fluid: boolean
  className?: string
}

const ContentDivider = ({ fluid, className }: Props) => {
  return (
    <>
      <div className={`divider-wrap ${className} ${fluid && 'fluid'}`}>
        <div className={`divider ${fluid && 'fluid'}`} />
      </div>
      <style jsx>
        {`
          .divider-wrap {
            position: relative;
            height: 50px;
          }
          .divider {
            text-align: center;
            padding: 0;
            background-image: url(${getCloudinaryThemeFileUrl('images/elements/divider-short.png')});
            height: 50px;
            background-repeat: no-repeat;
            background-size: auto 50px;
            margin-left: calc(-50vw + 50% + 7px);
            width: calc(100vw - 15px);
          }
          .divider.fluid {
            width: auto;
            position: relative;
            margin-left: initial;
            background-image: url(${getCloudinaryThemeFileUrl('images/elements/divider-long.png')});
            background-position: center;
            background-size: cover;
          }
        `}
      </style>
    </>
  )
}

export default ContentDivider
